import { Lock } from 'lucide-react'

import { useT } from '@/i18n'
import { cn } from '@/lib/cn'

/** 受保护账号名字旁边的小锁（D75）。 */
export function LockBadge({ className }: { className?: string }) {
  const t = useT()
  return (
    <Lock
      className={cn('inline size-3.5 shrink-0 text-ink-muted', className)}
      aria-label={t('protected.badge')}
      role="img"
    />
  )
}
